// extracted by mini-css-extract-plugin
export default {"feed":"FeedPhotos_feed__E+naL","boxMessage":"FeedPhotos_boxMessage__WT-X9"};